import React from 'react';
import { Users, BookOpen, Package, Star } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Star className="w-5 h-5 text-slate-300 fill-slate-300" data-id="element-329" />,
    text: '+500 clientes'
  }, {
    icon: <BookOpen className="w-5 h-5 text-slate-300" data-id="element-330" />,
    text: '6 Tomos completos'
  }, {
    icon: <Package className="w-5 h-5 text-slate-300" data-id="element-331" />,
    text: '4 Bonos incluidos'
  }, {
    icon: <Star className="w-5 h-5 text-slate-300 fill-slate-300" data-id="element-332" />,
    text: '4.9/5 calificación'
  }];
  return <div className="bg-[#1a0d2e] border-y border-[#3a2456] py-6" data-id="element-333">
      <div className="container mx-auto px-4" data-id="element-334">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center max-w-5xl mx-auto" data-id="element-335">
          {stats.map((stat, i) => <div key={i} className="flex items-center gap-2 font-medium text-slate-200" data-id="element-336">
              {stat.icon}
              <span data-id="element-337">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}